// Gardes de navigation : session ouverte, puis espace de travail actif.
import { Squelette } from '@cc/ui';
import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { AffichageErreur } from './commun/EtatRequete';
import { useSession } from './session/FournisseurSession';

function Attente() {
  return (
    <div style={{ padding: 32, maxWidth: 640, margin: '0 auto' }}>
      <Squelette lignes={5} libelle="Ouverture de la session" />
    </div>
  );
}

/** Exige une session ; sinon renvoie à la connexion en mémorisant la page demandée. */
export function GardeSession({ children }: { children?: ReactNode }) {
  const { etat } = useSession();
  const location = useLocation();
  if (etat === 'initialisation') return <Attente />;
  if (etat === 'deconnecte') return <Navigate to="/connexion" replace state={{ depuis: `${location.pathname}${location.search}` }} />;
  return children ?? <Outlet />;
}

/** Exige un espace de travail actif et utilisable. */
export function GardeContexte() {
  const { contexte, chargementContexte, erreurContexte, recharger } = useSession();
  const location = useLocation();
  if (chargementContexte) return <Attente />;
  if (erreurContexte || !contexte) {
    return (
      <div style={{ padding: 32, maxWidth: 640, margin: '0 auto' }}>
        <AffichageErreur erreur={erreurContexte} onReessayer={() => void recharger()} />
      </div>
    );
  }
  if (contexte.blocage?.code === 'mfa_requis') return <Navigate to="/mfa/activer" replace state={{ appartenanceId: contexte.appartenance_active?.id }} />;
  if (!contexte.appartenance_active || contexte.blocage) return <Navigate to="/contexte" replace />;
  // Le super administrateur de la plateforme n'a ni tableau de bord ni écrans métier : ses écrans sont sous /plateforme (D-080).
  if (contexte.appartenance_active.institution === 'plateforme' && !/^\/(plateforme|preferences)(\/|$)/.test(location.pathname)) {
    return <Navigate to="/plateforme/modules" replace />;
  }
  // Lot L6-A : les comptes institutionnels de supervision n'ont que l'espace /supervision (agrégats, D-008).
  if (contexte.appartenance_active.type === 'institutionnel' && contexte.appartenance_active.institution !== 'plateforme' && !/^\/(supervision|preferences)(\/|$)/.test(location.pathname)) return <Navigate to="/supervision" replace />;
  return <Outlet />;
}
